<template>
  <div
    class="dynamic"
  >
    <div v-html="content"></div>
  </div>
</template>

<script>
  export default {
    name: "Dynamic",
    data: function () {
      return {
        content: '',
        code: ''
      }
    },
    created: function () {
      this.code = this.$route.query.code;
      window.console.log(this.$route.query.code);
      this.getHtmlContent();
    },
    methods: {
      html_decode(str){
        let s = "";
        if (str.length === 0) return "";
        s = str.replace(/&amp;/g, "&");
        s = s.replace(/&lt;/g, "<");
        s = s.replace(/&gt;/g, ">");
        s = s.replace(/&nbsp;/g, " ");
        s = s.replace(/&#39;/g, "\"");
        s = s.replace(/&quot;/g, "\"");
        s = s.replace(/<br\/>/g, "\n");
        return s;
      },
      getHtmlContent: function () {
        window.console.log(this);
        this.$ajax.post('/user/appInfo?code='+this.code,{})
          .then(res => {
            if(res.status===200){
              this.content = res.data.data.content;
              document.title = res.data.data.title;
              window.console.log(res);
            }else{
              this.$toast('请求失败！请重试');
            }
          })
          .catch(error => {
            this.content = error.data;
            window.console.log(error);
          })
      }
    }
  }
</script>
<style lang="scss" type="text/scss">
  .dynamic{
    width: 100%;
    height: 100%;
    padding: 6vw 5vw;
    background-color: #fff;
    font-size: 16px;
    font-family: none;
    color: #000;
    div{
      width: 100%;
      margin: 3vw auto;
    }
    p{
      margin: 4.3vw 0;
    }
  }
</style>